import { DOCUMENT } from '@angular/common';
import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { addIcons } from 'ionicons';
import { eye, eyeOff, arrowBackCircle } from 'ionicons/icons';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  @HostBinding('class.navigated') hasNavigated = false;

  private router = inject(Router);
  private document = inject(DOCUMENT);

  constructor() {
    addIcons({
      eye,
      eyeOff,
      arrowBackCircle,
    });
  }

  ngOnInit() {
    this.setRouteTransitionsEnabled(false);

    this.router.events
      .pipe(
        filter((routerEvent): routerEvent is NavigationEnd => routerEvent instanceof NavigationEnd),
        take(1),
      )
      .subscribe(() => {
        this.hasNavigated = true;

        requestAnimationFrame(() => {
          this.setRouteTransitionsEnabled(true);
        });
      });
  }

  private setRouteTransitionsEnabled(isEnabled: boolean): void {
    const rootElement = this.document.documentElement;
    rootElement.classList.toggle('route-transitions-enabled', isEnabled);
  }
}
